export enum ERestaurantStatus {
  UNKNOWN = 0,
  REVIEWING = 1,
  ACTIVE = 2,
  DEACTIVATED = 3,
  BLACKLISTED = 4,
  PENDING = 5,
}
